var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Search'),_vm._l((_vm._confirmList),function(confirmItem){return _c('ConfirmItem',{key:confirmItem.id,attrs:{"confirmItem":confirmItem}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }